import * as _ from "lodash-es";
import axios from "axios";
import { notifyAxiosError } from "@/notify";
import { MAX_PAGE_SIZE } from "@/constants";

export default {
  namespaced: true,
  state: {
    formsMap: {},
    isFormsFetching: false,
    isFormsFetched: false,
  },
  mutations: {
    setForms: function (state, forms) {
      state.formsMap = _.keyBy(forms, "id");
    },
    setFormsFetching: function (state, isFormsFetching) {
      state.isFormsFetching = isFormsFetching;
    },
    setFormsFetched: function (state, isFormsFetched) {
      state.isFormsFetched = isFormsFetched;
    },
    updateForm: function (state, form) {
      state.formsMap = {
        ...state.formsMap,
        [form.id]: form,
      };
    },
  },
  getters: {
    getFormTitle(state) {
      return (formId) => {
        return state.formsMap[formId] && state.formsMap[formId].title;
      };
    },
    formsList(state) {
      return _.sortBy(Object.values(state.formsMap), "title");
    },
    formsOptions(state, getters) {
      return getters.formsList.map((form) => ({ value: form.id, text: form.title }));
    },
    assignableFormsOptions(state, getters) {
      return getters.formsList
        .filter((form) => !form.is_private && form.is_active && form.is_published)
        .map((form) => ({ value: form.id, text: form.title }));
    },
  },
  actions: {
    fetchForms(context) {
      if (context.state.isFormsFetching || context.state.isFormsFetched) {
        return;
      }
      context.commit("setFormsFetching", true);
      return axios.get("/forms/staff/", { params: { page_size: MAX_PAGE_SIZE } }).then(
        (response) => {
          context.commit("setFormsFetching", false);
          context.commit("setFormsFetched", true);
          context.commit("setForms", response.data.results);
        },
        (error) => {
          context.commit("setFormsFetching", false);
          notifyAxiosError(error);
        },
      );
    },
  },
};
